/* eslint-disable */
import React, { useLayoutEffect } from "react";
import { ManhattanLifeLogo, ShortTermDisabilityBrochure } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBShortTermDisabilityImage from "../../../../../assets/VEBPlanImages/VEBShortTermDisabilityImage.avif";
import "./shortTermDisability.scss";

const ShortTermDisability: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="gstd-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Short Term Disability Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={ManhattanLifeLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							When you or a loved one is affected by a short-term disability, the financial burden can be
							overwhelming. While primary health insurance is there to cover medical bills, many
							individuals face challenges due to time away from work and expenses that may not be covered
							by other insurance.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							A ManhattanLife Short Term Disability Insurance policy gives you an extra layer of
							financial security during these tough times—providing benefits that you can use to help keep
							the bills paid and protect your savings. That way, your focus can be on getting better.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBShortTermDisabilityImage} alt="VEBShortTermDisabilityImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={ShortTermDisabilityBrochure} />
			</div>
		</div>
	);
};

export default ShortTermDisability;
